import { render } from "./MapWarning.vue?vue&type=template&id=5fc1c162&scoped=true&bindings={\"msg\":\"props\"}"
import script from "./MapWarning.vue?vue&type=script&lang=js"
export * from "./MapWarning.vue?vue&type=script&lang=js"

import "./MapWarning.vue?vue&type=style&index=0&id=5fc1c162&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fc1c162"

export default script